import Vue from 'vue';
import Router from 'vue-router';

import Index from '../components/Index';
import Register from '../components/auth/Register';
import Login from '../components/auth/Login';
import UserAccount from '../components/user/UserAccount';
import Admin from '../components/admin/Admin';
import AdminPageForm from '../components/admin/AdminPageForm';
import PageView from '../components/PageView';
import AdminProductForm from '../components/admin/AdminProductForm';
import Products from '../components/ShopCategoryView';
import Categories from '../components/ShopCategories';
import Product from '../components/ProductView';
import Cart from '../components/Cart';
import Checkout from '../components/Checkout';
import Thanks from '../components/OrderThanks';
import Orders from '../components/admin/AdminOrders';
import Wedding from '../components/Wedding';
import Bar from '../components/Bar';
import Galla from '../components/Galla';

Vue.use(Router);

export default new Router({
  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/me/:page',
      name: 'Me',
      component: UserAccount,
    },
    {
      path: '/categories/',
      alias: '/holiday',
      name: 'Holiday',
      component: Categories,
    },
    {
      path: '/categories/',
      alias: '/everyday',
      name: 'Everyday',
      component: Categories,
    },
    {
      path: '/categories/',
      alias: '/weddings-&-events',
      name: 'WeddingsEvents',
      component: Categories,
    },
    {
      path: '/categories/:name',
      name: 'CategoryView',
      component: Categories,
    },
    {
      path: '/admin/orders',
      name: 'AdminOrders',
      component: Orders,
    },
    {
      path: '/admin',
      redirect: '/admin/0',
    },
    {
      path: '/admin/:active_tab',
      name: 'Admin',
      component: Admin,
    },
    {
      path: '/admin/page/new',
      name: 'AdminPageCreate',
      component: AdminPageForm,
    },
    {
      path: '/admin/page/:id',
      name: 'AdminPageEdit',
      component: AdminPageForm,
    },
    {
      path: '/admin/product/new',
      name: 'AdminProductCreate',
      component: AdminProductForm,
    },
    {
      path: '/admin/product/:id',
      name: 'AdminProductEdit',
      component: AdminProductForm,
    },
    {
      path: '/page/:id/:nice_name',
      name: 'PageView',
      component: PageView,
    },
    {
      path: '/page/3/contact_us',
      alias: '/contact',
      component: PageView,
    },
    {
      path: '/page/2/about_us',
      alias: '/about',
      component: PageView,
    },
    {
      path: '/page/4/payment_terms',
      alias: '/payment',
      component: PageView,
    },
    {
      path: '/page/5/privacy_policy',
      alias: '/privacy',
      component: PageView,
    },
    {
      path: '/page/6/care_and_handling',
      alias: '/care-and-handling',
      component: PageView,
    },
    {
      path: '/shop',
      name: 'Shop',
      component: Categories,
    },
    {
      path: '/shop/weddings-&-events/weddings',
      name: 'Wedding',
      component: Wedding,
    },
    {
      path: '/shop/weddings-&-events/bar%2Fbat-mitzvah',
      name: 'Bar',
      component: Bar,
    },
    {
      path: '/shop/weddings-&-events/corporate%2Fgala',
      name: 'Galla',
      component: Galla,
    },
    {
      path: '/shop/:ecat/:category',
      name: 'CategoryShop',
      component: Products,
    },

    {
      path: '/shop/:ecat/:category/:product_name',
      name: 'ProductView',
      component: Product,
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart,
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout,
    },
    {
      path: '/thanks',
      name: 'ThanksForOrdering',
      component: Thanks,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js